// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__118CG","title":"Images45_title__185FD","images":"Images45_images__hyy7s"};